// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"ffd25900","634":"31d6cfe0","733":"c0621dcf","754":"07f71517","775":"2a29a7de","900":"07f71517","904":"ad56619c","920":"18e40aac","971":"fd18bd43","980":"12ce20d6"}[chunkId] + ".chunk.css";
};